import { InjectionToken } from '@angular/core';
import { EqaDropdown } from '@shared/domain/interfaces/dropdown-directive';

export const EQA_DROPDOWN_DIRECTIVE = new InjectionToken<EqaDropdown>('Directive controlling eqaDropdownBoxComponent');
